<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.entrance']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="entranceId">
              <a-select
                allowClear
                :placeholder="language['column.pleaseChoose']+language['emp.apptype.entrance']"
                v-model="model.entranceId" :disabled="formDisabled"
              >
                <a-select-option v-for="(item,index) in entrances" :key="index.toString()" :value="item.id">
                  {{ item.entranceName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.commonlink.linkNo']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="linkNo">
              <a-input v-model="model.linkNo" :placeholder="language['trmorder.auto']"  disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.commonlink.linkName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="linkName">
              <a-input v-model="model.linkName" :placeholder="language['common.pleaseInput']+language['emp.commonlink.linkName']" maxLength=100   style="width: 85%" :disabled="formDisabled" ></a-input>
              <a-button @click="languageModelOpen('emp_entrance_common_link','link_name',linkNameLanguages)" type="primary"  style="left: 3%" >{{language['common.language']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.commonlink.linkUrl']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="linkUrl">
              <a-input v-model="model.linkUrl" :placeholder="language['common.pleaseInput']+language['emp.commonlink.linkUrl']" maxLength=255  :disabled="formDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.commonlink.default']+this.language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="imageUrl">
              <j-image-upload v-model="model.imageUrl"  :text="this.language['common.uploadButton']" :disabled="formDisabled"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="this.language['emp.commonlink.hover']+this.language['ad.image']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="hoverImageUrl">
              <j-image-upload v-model="model.hoverImageUrl"  :text="this.language['common.uploadButton']" :disabled="formDisabled"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.sort']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" :placeholder="language['common.pleaseInput']+language['emp.apptype.sort']" style="width: 100%" :min="1" :max="999999" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['emp.apptype.status']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-dict-select-tag type="radio" v-model="model.status" :trigger-change="true" dictCode="sys_portal_up_down" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['basedata.remark']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="remark">
              <a-textarea :placeholder="language['common.pleaseInput']+language['basedata.remark']" v-model="model.remark" :maxLength="ml" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <language-model ref="languageModel" @ok="languageOk"></language-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import LanguageModel from "@/components/LanguageModel"

  export default {
    name: 'EmpEntranceCommonLinkForm',
    components: {
      LanguageModel
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        url: {
          add: "/hhemp/commonlink/empentrancecommonlink",
          edit: "/hhemp/commonlink/empentrancecommonlink",
          queryById: "/hhemp/commonlink/empentrancecommonlink/"
        },
        entrances:[{
          id:'',
          colName:'',
          entranceName:''
        }],
        linkNameLanguages:[],
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        return {
          entranceId: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.apptype.entrance'] + '!'},
          ],
          linkName: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.commonlink.linkName'] + '!'},
          ],
          linkUrl: [
            { required: true, message: this.language['common.pleaseInput'] + this.language['emp.commonlink.linkUrl'] + '!'},
          ],
          imageUrl: [
            { required: true, message: this.language['warning.pleaseUploadImage']+'!'},
          ],
          hoverImageUrl: [
            { required: true, message: this.language['warning.pleaseUploadImage']+'!'},
          ],
          sortNo: [
            { required: true, message: this.language['common.mustSort']+'!'},
            //{ validator: this.validateToSortNo, trigger: 'blur'}
          ],
          status: [
            { required: true, message: this.language['common.pleaseChoose'] + this.language['emp.apptype.status'] + '!'},
          ],
        }
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.getEntranceList();
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.hasOwnProperty("id")){
          this.initLanguagetemp('emp_entrance_common_link','link_name',record.id)
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                /*that.$message.success(res.message);
                that.$emit('ok');*/
                this.linkNameLanguages.forEach(item=>{
                  if(!item.dataId){
                    item.dataId = res.result.id;
                  }
                })
                httpAction("/sys/syslanguagedata/saveSysLanguageDataList",this.linkNameLanguages,"post").then((res)=>{
                  if(res.success){
                    that.$message.success(res.message);
                    that.submitCallback();
                    that.confirmLoading = false;
                  }
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      getEntranceList(){
        httpAction("/hhemp/entrance/empcmsentrances?status=Y", "", "get").then((res) => {
          if (res.success) {
            this.entrances = res.result;
          }
        })
      },
      languageModelOpen(dataTable,dataColumn,languagelist){
        this.$refs.languageModel.edit("hhemp",dataTable,dataColumn,this.model.id,languagelist,this.disableSubmit);
      },
      languageOk(map){
        if(map&&map.dataColumn == 'link_name'){
          this.linkNameLanguages = map.languagelist;
        }
      },
      initLanguagetemp(dataTable,dataColumn,dataId) {
        getAction("/sys/syslanguagedata/querylistby", {
          applicationCode: "hhemp",
          dataTable: dataTable,
          dataColumn: dataColumn,
          dataId: dataId
        }).then((res) => {
          if (res.success) {
            this.linkNameLanguages = res.result;
          }
        })
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
    }
  }
</script>
